import { ifyouApiGame } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

/**
 * * 캐시 비우기
 */
export const cashingApis = {
  // 공지사항, 프로모션
  notice_promotion_cash: () =>
    ifyouApiGame
      .post(`/client`, { func: 'refreshCachePlatformEvent' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  // 로컬라이즈 텍스트
  localize_text_cash: () =>
    ifyouApiGame
      .post(`/client`, { func: 'refreshCachePlatformEvent' })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
